import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import commonSubFlowDefnFactories from 'edge/quoteandbind/common/config/FlowConfig';
import paFlowDefnFactory from 'conditional?if=quoteandbind_lob&equals=pa!edge/quoteandbind/pa/config/FlowConfig';
import puwFlowDefnFactory from 'conditional?if=quoteandbind_lob&equals=puw!customerEdge/quoteandbind/puw/config/FlowConfig';
import hoFlowDefnFactory from 'conditional?if=quoteandbind_lob&equals=ho!edge/quoteandbind/ho/config/FlowConfig';
import cpFlowDefnFactory from 'conditional?if=quoteandbind_lob&equals=cp!edge/quoteandbind/cp/config/FlowConfig';
import bopFlowDefnFactory from 'conditional?if=quoteandbind_lob&equals=bop!edge/quoteandbind/bop/config/FlowConfig';
import wc7FlowDefnFactory from 'conditional?if=quoteandbind_lob&equals=wc7!edge/quoteandbind/wc7/config/Wc7FlowConfig';

export default function (flow, AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ActionMessageUtil, EventHub, QuoteJumpToStepService) {

    /**
     * Convert object containing flow definitions into object containing sub flows
     * @param {Object} subFlowDefns containing flow definitions
     * @returns {Object}
     */
    function createSubFlowsFromFlowDefns(subFlowDefns) {
        const subFlowsContainer = {};
        Object.keys(subFlowDefns).reduce((container, flowDefnKey) => {
            container[flowDefnKey] = flow(subFlowDefns[flowDefnKey]);
            return container;
        }, subFlowsContainer);
        return subFlowsContainer;
    }

    const commonSubFlowDefns = commonSubFlowDefnFactories(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ActionMessageUtil, EventHub, QuoteJumpToStepService);

    const globalExits = flow(commonSubFlowDefns.globalExits);
    const availabilityFlow = flow(commonSubFlowDefns.availabilityCheck);
    const needToSaveCheckFlow = flow(commonSubFlowDefns.needToSaveCheck);
    const submissionExistsFlow = flow(commonSubFlowDefns.ensureSubmission);
    let paFlows;
    let puwFlows;
    let hoFlows;
    let cpFlows;
    let bopFlows;
    let wc7Flows;
    // if the personal auto feature is enabled then create the PA flow
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.pa')) {
        const paFlowDefns = paFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, EventHub);
        paFlows = createSubFlowsFromFlowDefns(paFlowDefns);
    }
    // if the PSA Used Auto Warranty feature is enabled then create the PUW flow
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.puw')) {
        const puwFlowDefns = puwFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ActionMessageUtil, EventHub, QuoteJumpToStepService);
        puwFlows = createSubFlowsFromFlowDefns(puwFlowDefns);
    }
    // if the homeowners feature is enabled then create the HO flow
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.ho')) {
        const hoFlowDefns = hoFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx);
        hoFlows = createSubFlowsFromFlowDefns(hoFlowDefns);
    }
    // if the commercial property feature is enabled then create the CP flow
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.cp')) {
        const cpFlowDefns = cpFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, EventHub);
        cpFlows = createSubFlowsFromFlowDefns(cpFlowDefns);
    }
    // if the BOP feature is enabled then create the BOP flow
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.bop')) {
        const bopFlowDefns = bopFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, EventHub);
        bopFlows = createSubFlowsFromFlowDefns(bopFlowDefns);
    }
    // if the WC7 feature is enabled then create the WC7 flow
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.wc7')) {
        const wc7FlowDefns = wc7FlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx);
        wc7Flows = createSubFlowsFromFlowDefns(wc7FlowDefns);
    }
    // PSA TODO - for some unfound defect in platform, if 'quote' subflows left here, it takes over puw.quote subflow (at least step name)
    // const quoteFlow = flow(commonSubFlowDefns.quote);
    const bindFlow = flow(commonSubFlowDefns.bindAndPay);

    return {
        exit: globalExits,
        availability: availabilityFlow,
        needToSaveCheck: needToSaveCheckFlow,
        submissionExists: submissionExistsFlow,
        paFlows,
        puwFlows,
        hoFlows,
        cpFlows,
        bopFlows,
        wc7Flows,
        // PSA TODO quote: quoteFlow,
        bind: bindFlow
    };
}
